import { connect } from "react-redux";
import { hideLoading, showLoading } from "../../actions/loaderAction";
import { ToastContainer } from "react-toastify";
import AcSimpleTable from "../../components/AcSimpleTable";
import ButtonAdd from "../../components/ButtonAdd";
import InputField from "../../components/InputField";
import SubHeader from "../../components/SubHeader";
import SmallPopup from "../../components/SmallPopup";
import DropDown from "../../components/DropDown";
import MediumPopup from "../../components/MediumPopup";
import { useEffect, useRef, useState } from "react";
import { showErrorMessage, showSuccessMessage } from "../../utils/common";
import errorMessages from "../../constant/errorMessages";
import { isEmpty, omit, size } from "lodash";
import defaultValues from "../../constant/defaultValues";
import { createPort, deletePort, getPorts, updatePort } from "../../actions/dictionaryAction";
import { countryList } from "../../actions/countryAction";
import ToolipsCustom from "../../components/ToolipsCustom";
import { useParams } from "react-router-dom";
import RadioButtonField from "../../components/RadioButtonField";
import axios from "axios";
import API_URL from "../../constant/api.config";
import { encode } from "js-base64";
import regExp from "../../constant/regExpressions";
import { useAuth } from "@/AuthProvider";

function ManagePorts(props) {
  const { admin } = defaultValues;
  const { isAdmin } = useAuth();
  const [offset, setOffset] = useState(admin.OFFSET);
  const [limit, setLimit] = useState(admin.LIMIT);
  const [searchTxt, setSearchTxt] = useState("");
  const [portList, setPortList] = useState([]);
  const [totalRows, settotalRows] = useState(0);
  const [loading, setLoading] = useState(false);
  const [mediummodalShow, setMediumModalShow] = useState(false);
  const [editPortId, setEditPortId] = useState();
  const [errors, setErrors] = useState({});
  const [smallmodalShow, setSmallModalShow] = useState(false);
  const [deletePortId, setDeletePortId] = useState();
  const [countryList, setCountryList] = useState([]);
  const [country, setCountry] = useState(null);
  const [port, setPort] = useState("");
  const [portCode, setPortCode] = useState("");
  const initialRef = useRef(true);
  const [columnName, setColumnName] = useState(admin.COLUMN_NAME);
  const [sortDirection, setSortDirection] = useState(admin.SORT_DIRECTION);
  const [current_page, setCurrentPage] = useState(1);
  const [tableKey, setTableKey] = useState(0);
  const [nodata, setNoData] = useState(false);
  const [portAction, setPortAction] = useState("Approve");
  const [approvedCountryList, setApprovedCountryList] = useState([]);
  const [approvedCountry, setApprovedCountry] = useState(null);
  const [approvedPortList, setApprovedPortList] = useState([]);
  const [approvedPort, setApprovedPort] = useState();


  const { port_status } = useParams();


  const columns = [
    {
      name: "Sr No",
      selector: (row, idx) => {
        return <>{offset + (idx + 1)}</>;
      },
      resizable: true,
      width: "10%",
    },
    {
      name: "Port Name",
      selector: (row) => (
        <div className="tbl-text-wrap-row">
          {row.name ? row.name : "-"}
        </div>
      ),
      columnName: "name",
      resizable: true,
      width: "30%",
      sortable: true
    },
    {
      name: "Country",
      selector: (row) => (
        <div className="tbl-text-wrap-row">{row.country.name ? row.country.name : "-"}</div>
      ),
      resizable: true,
      width: "15%",
      columnName: "country_name",
      sortable: true
    },
    {
      name: "Port Code",
      selector: (row) => (
        <div className="tbl-text-wrap-row">
          {row.port_code ? row.port_code : "-"}
        </div>
      ),
      columnName: "port_code",
      resizable: true,
      width: "15%",
      sortable: true
    },
    {
      name: "Created By",
      selector: (row) => (
        <div className="text-wrap">
          {row.created_by ? row.created_by.name : "-"}
        </div>
      ),
      resizable: true,
      width: "10%",
    },
    {
      name: "Updated By",
      selector: (row) => (
        <div className="text-wrap">
          {row.updated_by ? row.updated_by.name : "-"}
        </div>
      ),
      resizable: true,
      width: "10%",
    },
    {
      omit: isAdmin,
      name: "Actions",
      cell: (row) => (
        // !isAdmin &&
        <>
          {/* <button
            className="btn"
            onClick={() => handleEditClick(row)}
            data-toggle="tooltip"
            data-placement="top"
            title="Edit"
          >
            <i className="fa-regular fa-pen-to-square icon-pen"></i>
          </button> */}

          <ToolipsCustom
            subtitle="Edit"
            className="fa-regular fa-pen-to-square icon-pen border-0 "
            classNameChild={"data-table-tooltiop"}
            onClick={() => handleEditClick(row)}
          ></ToolipsCustom>
          {/* <button
            className="btn"
            onClick={() => handleDeleteClick(row.id)}
            data-toggle="tooltip"
            data-placement="top"
            title="Delete"
          >
            <i
              className="fa-solid fa-trash-can icon-trash"
              aria-hidden="true"
            ></i>
          </button> */}

          <ToolipsCustom
            subtitle="Delete"
            className="fa-solid fa-trash-can icon-trash border-0 "
            classNameChild={"data-table-tooltiop"}
            onClick={() => handleDeleteClick(row.id)}
          ></ToolipsCustom>
        </>
      ),
      resizable: true,
      ignoreRowClick: true,
      allowoverflow: true,
      button: true,
      width: "10%",
      // minWidth: "200px"
    },
  ];

  const handleSort = async (column, sortDirection) => {
    setColumnName(column.columnName);
    setSortDirection(sortDirection);
    // getPortList(
    //   admin.OFFSET,
    //   admin.LIMIT,
    //   current_page,
    //   column.columnName,
    //   sortDirection,
    //   searchTxt
    // );
    getPortList(
      offset,
      limit,
      current_page,
      column.columnName,
      sortDirection,
      searchTxt
    );
  };

  const onSearchTextBoxChanged = (e) => {
    setSearchTxt(e.target.value);
    let searchVal = e.target.value;
    if (searchVal.length >= 3 || searchVal.length <= 0) {
      setOffset(admin.OFFSET);
      setLimit(admin.LIMIT);
      setColumnName(admin.COLUMN_NAME);
      setSortDirection(admin.SORT_DIRECTION);
      setTableKey((prev) => prev + 1);
      getPortList(admin.OFFSET, admin.LIMIT, current_page, admin.COLUMN_NAME, admin.SORT_DIRECTION, e.target.value);
    }
  };

  const getPortList = async (offset, limit, current_page, columnName, sortDirection, searchTxt) => {
    setNoData(false);
    await props.showLoading();
    await props
      .getPorts(port_status, offset, limit, columnName, sortDirection, searchTxt)
      .then((response) => {
        setPortList([]);
        if (size(response.data) === 0) {
          setNoData(true);
        }
        setPortList(response.data);
        settotalRows(response.metadata.total);
      })
      .catch((err) => {
        console.log("Error ==== ", err);
        showErrorMessage("Something Went Wrong!!");
      });
    await props.hideLoading();
  };

  const fetchCountries = async () => {
    await props
      .getCountries()
      .then((response) => {
        if (response.status === true) {
          const options = response.data.map((country) => ({
            value: country.id,
            label: country.name
          }));
          setCountryList(options);
          setApprovedCountryList(options);
        }
      })
      .catch((err) => {
        console.log("Error =", err);
        showErrorMessage("Something went wrong");
      });
  };

  const handleApprovedCountryChange = (cval) => {
    setApprovedCountry(cval);
    fetchCountryPorts(cval.value);
  };

  const handleApprovedPortChange = (val) => {
    setApprovedPort(val);
  };

  const handleInputChange = (inputVal) => {
    if (inputVal.length >= 3) {
      fetchAllPorts(0, 10, inputVal);
    }
  };

  const fetchCountryPorts = async (countryId) => {
    await axios
      .get(API_URL + "/country-port-list/" + countryId)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.status === true) {
            const options = response.data.data.map((port) => ({
              value: port.id,
              label: port.name,
            }));
            setApprovedPortList(options);
          }
        }
      })
      .catch((err) => {
        console.log("Error ========== ", err);
      });
  }

  const fetchAllPorts = async (offset, limit, searchTxt = "") => {
    let searchQuery = "";
    if (!isEmpty(searchTxt)) {
      searchQuery = "/" + encode(searchTxt);
    }
    await axios
      .get(API_URL + "/all-port-list/" + offset + "/" + limit + searchQuery)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.status === true) {
            const options = response.data.data.map((port) => ({
              value: port.id,
              label: port.name,
            }));
            setApprovedPortList(options);
          }
        }
      })
      .catch((err) => {
        console.log("Error ========== ", err);
      });
  }

  const handleEditClick = async (row) => {
    // await props.showLoading();
    setErrors({});
    setPortAction("Approve");
    setPort(row.name);
    setPortCode(row.port_code);
    const selectedCountryOption = countryList.find(
      (option) => option.value == row.country_id
    );
    setCountry(selectedCountryOption);
    setEditPortId(row.id);
    setApprovedPort("");
    setApprovedCountry(selectedCountryOption);
    fetchCountryPorts(selectedCountryOption.value);
    setMediumModalShow(true);

    // await props.hideLoading();
  };

  const handleFocusOut = (e) => {
    let errObj = { ...errors };
    if (e.target.name === "port") {
      if (isEmpty(e.target.value)) {
        errObj.port = errorMessages.FIELD_REQUIRED;
      } else {
        // errObj.port = "";
        const regExpPort = regExp.port_name;
        const check = regExpPort.test(e.target.value);
        if (check === false) {
          errObj.port = errorMessages.IN_VALID_FIELD_FORMAT;
        }
        else {
          errObj.port = "";
        }
      }
    }
    if (e.target.name === "port_code") {
      if (isEmpty(e.target.value)) {
        errObj.portCode = errorMessages.FIELD_REQUIRED;
      } else {
        const regExpCode = /^[a-zA-Z][a-zA-Z\d\s]*$/;
        const check = regExpCode.test(e.target.value);
        if (check === false) {
          errObj.portCode = errorMessages.IN_VALID_FIELD_FORMAT;
        } else {
          errObj.portCode = "";
        }
      }
    }
    setErrors(errObj);
  };

  const validForm = () => {
    let er = {};
    let errFlag = 0;

    if (isEmpty(port)) {
      errFlag = 1;
      er.port = errorMessages.FIELD_REQUIRED;
    } else {
      const regExpPort = regExp.port_name;
      const check = regExpPort.test(port);
      if (check === false) {
        errFlag = 1;
        er.port = errorMessages.IN_VALID_FIELD_FORMAT;
      }
    }

    if (isEmpty(portCode) && portAction == "Approve") {
      errFlag = 1;
      er.portCode = errorMessages.FIELD_REQUIRED;
    } else if (!isEmpty(portCode) && portAction == "Approve") {
      const regExpCode = /^[a-zA-Z][a-zA-Z\d\s]*$/;
      const check = regExpCode.test(portCode);
      if (check === false) {
        errFlag = 1;
        er.portCode = errorMessages.IN_VALID_FIELD_FORMAT;
      }
    }

    if (isEmpty(country)) {
      errFlag = 1;
      er.country = errorMessages.FIELD_REQUIRED;
    }

    if (portAction == "Map_To_Other") {
      if (isEmpty(approvedCountry)) {
        errFlag = 1;
        er.approvedCountry = errorMessages.FIELD_REQUIRED;
      }
      if (isEmpty(approvedPort)) {
        errFlag = 1;
        er.approvedPort = errorMessages.FIELD_REQUIRED;
      }
    }

    setErrors(er);
    if (errFlag == 1) {
      return false;
    } else {
      return true;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // setMediumModalShow(false);

    if (validForm()) {
      props.showLoading();
      if (editPortId > 0) {
        const reqObj = {
          name: port,
          port_code: portCode,
          id: editPortId,
          action: portAction,
          mapped_port: approvedPort,
          country_id: country.value,
          port_status: port_status
        };
        await props
          .updatePort(editPortId, reqObj)
          .then((response) => {
            if (response.status === true) {
              setMediumModalShow(false);
              setOffset(admin.OFFSET);
              setLimit(admin.LIMIT);
              setColumnName(admin.COLUMN_NAME);
              setSortDirection(admin.SORT_DIRECTION);
              setSearchTxt("");
              getPortList(admin.OFFSET, admin.LIMIT, current_page, admin.COLUMN_NAME, admin.SORT_DIRECTION, "");
              showSuccessMessage(response.message);
            } else if (response.status === false) {
              let errObj = {};
              if (response.error == 'The data has already been taken.') {
                errObj.availablePort = response.error;
              }
              if (response.error.name) {
                errObj.port = response.error.name[0];
              }
              if (response.error.port_code) {
                errObj.portCode = response.error.port_code[0];
              }
              setErrors(errObj);
            }
          })
          .catch((err) => {
            console.log("Error =======> ", err);
            showErrorMessage("something went wrong!");
          });
      } else {
        const reqData = {
          name: port,
          country_id: country.value,
          port_code: portCode
        };
        await props
          .createPort(reqData)
          .then((response) => {
            if (response.status === true) {
              setMediumModalShow(false);
              setOffset(admin.OFFSET);
              setLimit(admin.LIMIT);
              setColumnName(admin.COLUMN_NAME);
              setSortDirection(admin.SORT_DIRECTION);
              setSearchTxt("");
              getPortList(admin.OFFSET, admin.LIMIT, current_page, admin.COLUMN_NAME, admin.SORT_DIRECTION, "");
              showSuccessMessage(response.message);
            } else if (response.status === false) {
              let errObj = {};
              if (response.error == 'The data has already been taken.') {
                errObj.availablePort = response.error;
              }
              if (response.error.name) {
                errObj.port = response.error.name[0];
              }
              if (response.error.port_code) {
                errObj.portCode = response.error.port_code[0];
              }
              setErrors(errObj);
            }
          })
          .catch((err) => {
            console.log("Error ====== ", err);
            showErrorMessage("Something Went Wrong!!");
          });
      }
      props.hideLoading();
    }
  };

  const handleCountryChange = (cval) => {
    setCountry(cval);
  };

  const handleChange = (e) => {
    if (e.target.name == "port") {
      setPort(e.target.value);
    }
    if (e.target.name == "port_code") {
      setPortCode(e.target.value);
    }

  };

  const handleAddPortClick = () => {
    setPort();
    setPortCode();
    setCountry();
    setErrors({});
    setEditPortId(0);
    setMediumModalShow(true);
  };

  const handleDeleteClick = (id) => {
    setSmallModalShow(true);
    setDeletePortId(id);
  };

  const handleConfirmDeleteClick = () => {
    props
      .deletePort(deletePortId)
      .then((response) => {
        if (response.status === true) {
          showSuccessMessage("Port Deleted Successfully");
          setOffset(admin.OFFSET);
          setLimit(admin.LIMIT);
          setColumnName(admin.COLUMN_NAME);
          setSortDirection(admin.SORT_DIRECTION);
          setSearchTxt("");
          getPortList(admin.OFFSET, admin.LIMIT, current_page, admin.COLUMN_NAME, admin.SORT_DIRECTION, "");
        } else if (response.status === false) {
          if (response.error === "The port is already used by some company") {
            showErrorMessage("This port cannot be deleted as it is associated with existing users.");
          }
        }
        setSmallModalShow(false);
      })
      .catch((err) => {
        console.log("Error == ", err);
        showErrorMessage("Something Went Wrong!!");
      });
  };

  const handlePortActionChange = (e, port_action) => {
    if (port_action === "Approve") {
      setPortAction("Approve");
    } else if (port_action === "Map_To_Other") {
      setPortAction("Map_To_Other");
    }
  };

  useEffect(() => {
    // if (initialRef.current === true) {
    //   initialRef.current = false;
    getPortList(offset, limit, current_page, columnName, sortDirection, "");
    fetchCountries();
    setSearchTxt("");
    // }

  }, [port_status]);

  return (
    <>
      <div className="data-table-main">
        <div className="AcSimpleTable">
          <MediumPopup
            title={editPortId > 0 ? "Edit Port" : "Create Port"}
            mediummodalShow={mediummodalShow}
            setMediumModalShow={setMediumModalShow}
            onSubmit={handleSubmit}
            okButtonLabel={editPortId > 0 ? "Update" : "Create"}
            closeButtonLabel="Cancel"
          >
            <form onSubmit={handleSubmit}>
              {/* <div className="row justify-content-cetner align-items-center"> */}
              <div className="row my-3">
                <div className="col-xl-6 mt-2">
                  <label className="popup-input-lable field-required">
                    Port Name
                  </label>
                  <InputField
                    className=""
                    placeholder={"Enter Port Name"}
                    name="port"
                    onChange={handleChange}
                    onBlur={handleFocusOut}
                    value={port}
                    disabled={portAction == "Map_To_Other" ? true : false}
                    autoComplete="off"
                  ></InputField>

                  {errors.port && (
                    <p
                      className="invalid-feedback"
                      style={{ display: "block" }}
                    >
                      {errors.port}
                    </p>
                  )}
                  {errors.availablePort && (
                    <p
                      className="invalid-feedback"
                      style={{ display: "block" }}
                    >
                      {errors.availablePort}
                    </p>
                  )}
                </div>
                <div className="col-xl-6 mt-2">
                  <label className="profile-text mb-1">
                    Select Country
                    <span className="text-danger"> *</span>
                  </label>
                  <DropDown
                    placeholder={"Select country"}
                    className={"input-error-border"}
                    options={countryList}
                    value={country}
                    onChange={handleCountryChange}
                    isDisabled={portAction == "Map_To_Other" || (port_status == 1 && editPortId > 0) ? true : false}
                  ></DropDown>
                  {errors.country && (
                    <p
                      className="invalid-feedback"
                      style={{ display: "block" }}
                    >
                      {errors.country}
                    </p>
                  )}
                </div>
                {portAction == 'Approve' &&
                  <div className="col-xl-6 mt-2">
                    <label className="popup-input-lable field-required">
                      Port Code
                    </label>

                    <InputField
                      className=""
                      placeholder={"Enter Port Code"}
                      name="port_code"
                      onChange={handleChange}
                      onBlur={handleFocusOut}
                      value={portCode}
                      disabled={portAction == "Map_To_Other" ? true : false}
                      autoComplete="off"
                    ></InputField>

                    {errors.portCode && (
                      <p
                        className="invalid-feedback"
                        style={{ display: "block" }}
                      >
                        {errors.portCode}
                      </p>
                    )}
                  </div>
                }

                {port_status == 0 && (
                  <div>
                    <div className="col-xl-12 my-2">
                      <label className="profile-text">
                        {" "}
                        Port Action <span className="text-danger">*</span>
                      </label>
                      <div className="d-flex">
                        <div className="mt-2">
                          <RadioButtonField
                            onChange={(e) => handlePortActionChange(e, "Approve")}
                            checked={portAction == "Approve"}
                          />
                          <label className="">Approve</label>
                        </div>
                        <div className="mt-2">
                          <RadioButtonField
                            onChange={(e) =>
                              handlePortActionChange(e, "Map_To_Other")
                            }
                            checked={portAction == "Map_To_Other"}
                          />
                          <label className="">Map to Other Port</label>
                        </div>
                      </div>
                    </div>


                    {/* <div className="mt-2"> */}
                    {portAction == "Map_To_Other" && (
                      <div className="row">

                        <div className="col-xl-6 my-2">
                          <label className="profile-text">
                            Select Country
                            <span className="text-danger"> *</span>
                          </label>
                          <DropDown
                            placeholder={"Select country"}
                            className={"input-error-border"}
                            options={approvedCountryList}
                            value={approvedCountry}
                            onChange={handleApprovedCountryChange}
                          ></DropDown>
                          {errors.approvedCountry && (
                            <p
                              className="invalid-feedback"
                              style={{ display: "block" }}
                            >
                              {errors.approvedCountry}
                            </p>
                          )}
                        </div>

                        <div className="col-xl-6 my-2">
                          <label className="profile-text">
                            Select Approved Port
                            <span className="text-danger"> *</span>
                          </label>

                          <DropDown
                            placeholder={"Select Approved Port"}
                            className={"input-error-border"}
                            options={approvedPortList}
                            onChange={handleApprovedPortChange}
                            onInputChange={handleInputChange}
                            value={approvedPort}
                          ></DropDown>
                          {errors.approvedPort && (
                            <p
                              className="invalid-feedback"
                              style={{ display: "block" }}
                            >
                              {errors.approvedPort}
                            </p>
                          )}
                        </div>

                      </div>
                    )}
                    {/* </div> */}


                  </div>
                )}
              </div>
            </form>
          </MediumPopup>
          <SmallPopup
            title="Delete Port"
            smallmodalShow={smallmodalShow}
            setSmallModalShow={setSmallModalShow}
            onSubmit={handleConfirmDeleteClick}
            closeButtonLabel="Cancel"
            okButtonLabel="Delete"
          >
            <div className="row my-3">
              <div className="col-md-12 p-0">
                Are you sure you want to delete Port?
              </div>
            </div>
          </SmallPopup>

          <SubHeader
            layer1="Dictionary Management"
            layer2={port_status == 1 ? "Verified" : "Curated"}
            layer3="Ports"
            pageName="Ports"
            subTitle=""
            clickable={{
              layer1: "",
              layer2: "",
              layer3: ""
            }}
          />

          <div className="AcSimpleTable">
            <div className="card1">
              <div className="table-header-name">
                <h5 className="table-text py-3">List</h5>
                <div className="d-flex flex-wrap justify-content-between align-items-center py-3">
                  <label className="mx-3">Search</label>
                  <InputField
                    type="text"
                    id="filter-text-box"
                    placeholder="Search..."
                    className="w-25"
                    onChange={onSearchTextBoxChanged}
                    value={searchTxt}
                    autoComplete="off"
                  ></InputField>

                  {port_status == 1 && !isAdmin &&(
                    <ButtonAdd
                      type="button"
                      className="btn-add me-0"
                      onClick={handleAddPortClick}
                    >
                      {" "}
                      <i className="fa-solid fa-circle-plus"></i> Add New Port
                    </ButtonAdd>
                  )}
                </div>
              </div>

              <div className="table-wrapper">
                <div className="table-container">
                  {portList && (
                    <AcSimpleTable
                      key={tableKey}
                      data={portList}
                      title=""
                      pagination={true}
                      paginationPageSize={limit}
                      columns={columns}
                      progressPending={loading}
                      paginationTotalRows={totalRows}
                      fixedColumnsStart={admin.FIXED_COLUMNS_START}
                      getData={getPortList}
                      offset={offset}
                      limit={limit}
                      columnName={columnName}
                      sortDirection={sortDirection}
                      setLimit={setLimit}
                      setOffset={setOffset}
                      setColumnName={setColumnName}
                      setSortDirection={setSortDirection}
                      setLoading={setLoading}
                      paginationPerPage={limit}
                      paginationRowsPerPageOptions={admin.PAGINATE_RANGE}
                      striped
                      searchTxt={searchTxt}
                      sortServer
                      onSort={handleSort}
                      defaultSortAsc={false}
                      setCurrentPage={setCurrentPage}
                      noData={nodata}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* <ToastContainer /> */}
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    getPorts: (port_status, offset, limit, columnName, sortDirection, searchTxt) => dispatch(getPorts(port_status, offset, limit, columnName, sortDirection, searchTxt)),
    getCountries: () => dispatch(countryList()),
    updatePort: (id, data) => dispatch(updatePort(id, data)),
    createPort: (data) => dispatch(createPort(data)),
    deletePort: (id) => dispatch(deletePort(id)),
    showLoading: () => dispatch(showLoading()),
    hideLoading: () => dispatch(hideLoading()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ManagePorts);
